import React from 'react';
import cx from 'classnames';
import SkillBoxProps from '../types/SkillBoxProps';
import style from './Skill.module.css';

/**
 * ## Shows the skill element with icon and name
 * When you click on it, it opens a modal.
 *
 * @param {skill} - Skill
 * @returns
 */
function SkillBox({ skill, onClick }: SkillBoxProps) {
  return (
    <article
      className={`${style.tech} tech`}
      onClick={() => onClick && onClick(skill.id)}
    >
      <img
        src={skill.image}
        alt={skill.name}
        width="128"
        height="128"
        className={cx(style.image, { [style.grayFilter]: skill.addGrayFilter })}
      />
      <span className={style.skillName}>{skill.name}</span>
    </article>
  );
}

export default SkillBox;
